/* assets/go-crm-samples.js — the free-samples page (sections/go-crm-samples.liquid). DOM only; rules live in Brewery OS.
   Every visitor/API string reaches the DOM through textContent (or an attribute/property), never innerHTML. */
(function () {
  var L = window.GoCrmSamples;
  var root = document.getElementById('gcs');
  if (!L || !root) return;
  var data;
  try { data = JSON.parse(document.getElementById('gcs-data').textContent); }
  catch (e) {
    data = {
      api: 'https://os.gobrewing.com',
      wholesaleUrl: '/pages/wholesale-apply',
      copy: {fedex: 'Ships next business day via FedEx. Usually there in about 3 days.'},
      prospect: [], botm: [], direct: [], popular_rank: []
    };
  }
  ['prospect', 'botm', 'direct', 'popular_rank'].forEach(function (k) { if (!Array.isArray(data[k])) data[k] = []; });
  var P = L.readParams(location.search);
  var $ = function (id) { return document.getElementById(id); };
  var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  // DISPLAY ONLY (cuts the subtitle after a spaced dash). The full title still goes to the samples lookup.
  var displayName = L.displayName;
  var reduceMotion = function () { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var cards = {};   // key → {name, image}
  var tray = [];
  var flying = {};  // tray slot index → true while a thumbnail is still flying to it
  var venueInfo = null;
  var samplesLoaded = false;
  var byName = {};  // samples-lookup answer, by the name we sent (the API echoes it)
  try { tray = JSON.parse(sessionStorage.getItem('gcs-tray') || '[]').filter(function (k) { return typeof k === 'string'; }).slice(0, L.MAX); } catch (e) { tray = []; }
  var save = function () { try { sessionStorage.setItem('gcs-tray', JSON.stringify(tray)); } catch (e) {} };
  var lookupName = function (item) { return String((item && item.name) || '').trim().slice(0, 120); };
  var matchOf = function (item) { return byName[lookupName(item)] || null; };
  var keyOf = function (item) { var m = matchOf(item); return (m && m.key) || null; };

  // ---- analytics: the theme's own window.goTrack (snippets/go-mixpanel.liquid; it already sends page_viewed).
  // No PII in props — never the venue name, email, phone or address.
  // Mixpanel adds $current_url to every event, and these links carry ?venue=<business name>. Send the URL with
  // ONLY `venue` removed (t, utm_*, distributor, beers, premise stay for attribution). go-mixpanel.liquid does the
  // same for its own events on this page.
  var safeUrl_ = (function () { try { var u = new URL(location.href); u.searchParams.delete('venue'); return u.toString(); } catch (e) { return location.origin + location.pathname; } })();
  var sent = {};
  function trackProps(props) {
    var base = {has_token: !!P.t, $current_url: safeUrl_};
    if (P.utm.utm_campaign) base.utm_campaign = P.utm.utm_campaign;
    if (P.utm.utm_source) base.utm_source = P.utm.utm_source;
    return Object.assign(base, props || {});
  }
  function track(name, props, once) {
    if (once) { if (sent[name]) return; sent[name] = 1; }
    if (typeof window.goTrack !== 'function') return;
    try { window.goTrack(name, trackProps(props)); } catch (e) {}
  }
  // For a click that navigates away: sendBeacon survives the unload (goTrack's default XHR may not).
  function trackBeforeLeaving(name, props) {
    var mp = window.mixpanel;
    if (mp && typeof mp.track === 'function' && mp.__loaded) {
      try { mp.track(name, Object.assign({page_type: 'page', page_handle: 'samples'}, trackProps(props)), {transport: 'sendBeacon'}); return; } catch (e) {}
    }
    track(name, props);
  }

  function greet(v) {
    // The brewery-town proof line only for Illinois venues (L.proofLine) — set as text, never in markup.
    $('gcs-proof-2').textContent = L.proofLine(v);
    // URLSearchParams (in readParams) already decoded the name once; it is only ever set as text.
    var name = (v && v.venue && v.venue.name) || P.venue;
    $('gcs-greet').textContent = L.heroEyebrow(name);   // their name as the hero eyebrow, else "For bars & restaurants"
  }

  // ---- motion: sections reveal through the DS [data-ds-reveal] utility (gb-design-system); here only the Add
  // interaction (bounce + fly-to-tray), all ≤ 400 ms and off under reduced motion. ----
  // ---- icons: Lucide-style inline SVG (L.ICONS), built with DOM calls, aria-hidden ----
  function icon(name, size) {
    var NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg');
    var at = {viewBox: '0 0 24 24', width: size || 20, height: size || 20, fill: 'none', stroke: 'currentColor', 'stroke-width': 2,
      'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false', 'class': 'gcs-ic'};
    Object.keys(at).forEach(function (k) { svg.setAttribute(k, at[k]); });
    (L.ICONS[name] || []).forEach(function (part) {
      var n = document.createElementNS(NS, part[0]);
      Object.keys(part[1]).forEach(function (k) { n.setAttribute(k, part[1][k]); });
      svg.appendChild(n);
    });
    return svg;
  }
  function restart(node, cls) { node.classList.remove(cls); void node.offsetWidth; node.classList.add(cls); }
  function flyToTray(tile, idx) {
    var slot = $('gcs-slots').children[idx];
    var img = tile.querySelector('img');
    var from = tile.getBoundingClientRect(), to = slot && slot.getBoundingClientRect();
    if (!img || !img.src || img.hidden || !to || !from.width || !to.width) { land(idx); return; }
    var f = el('img', 'gcs-flyer'); f.alt = ''; f.setAttribute('aria-hidden', 'true'); f.src = img.src;
    f.style.left = from.left + 'px'; f.style.top = from.top + 'px'; f.style.width = from.width + 'px'; f.style.height = from.height + 'px';
    f.style.padding = Math.round(from.width * 0.12) + 'px';
    document.body.appendChild(f);
    void f.offsetWidth;
    f.style.transform = 'translate(' + (to.left - from.left) + 'px,' + (to.top - from.top) + 'px) scale(' + (to.width / from.width) + ')';
    var done = false;
    var finish = function () { if (done) return; done = true; if (f.parentNode) f.parentNode.removeChild(f); land(idx); };
    f.addEventListener('transitionend', finish);
    setTimeout(finish, 380);
  }
  function land(idx) {
    if (!flying[idx]) return;
    delete flying[idx];
    var slot = $('gcs-slots').children[idx];
    if (slot && tray[idx]) { slot.classList.remove('is-landing'); if (!reduceMotion()) restart(slot, 'is-pop'); }
    setMsg(true);
  }
  function inFlight() { return Object.keys(flying).length; }
  function setMsg(tick) {
    var m = $('gcs-msg');
    m.textContent = L.trayMessage(tray.length - inFlight());
    if (tick && !reduceMotion()) restart(m, 'is-tick');
  }

  function card(item, match, opts) {
    opts = opts || {};
    var c = el('article', 'gcs-card');
    var tile = el('div', 'gcs-tile');
    var img = el('img'); img.alt = ''; img.loading = opts.eager ? 'eager' : 'lazy'; img.decoding = 'async';
    var src = item.image || (match && match.image) || '';
    if (src) img.src = src; else img.hidden = true;
    tile.appendChild(img);
    if (opts.tag) tile.appendChild(el('p', 'gcs-tag', opts.tag));
    var in4 = el('p', 'gcs-in4'); in4.appendChild(icon('check', 12)); in4.appendChild(document.createTextNode('In your 4')); tile.appendChild(in4);
    c.appendChild(tile);
    var name = displayName(item.name);
    var notes = opts.notes ? notesPanel(opts.notes, name) : null;
    if (notes) tile.appendChild(notes.toggle);
    // Style first (the beer's name may not mean anything to a new buyer yet); the name goes under it.
    // aria-labels on Add / − / info keep using the beer name.
    var titles = L.cardTitles(item.name, opts.style);
    var h = el('h3', 'gcs-title');
    h.appendChild(el('span', 'gcs-name', titles.primary));
    if (titles.secondary) { var bn = el('span', 'gcs-beer', titles.secondary); bn.title = titles.secondary; h.appendChild(bn); }
    c.appendChild(h);
    var rl = L.ratingLabel(opts.rating);
    if (rl) {
      var rate = el('p', 'gcs-rate'); rate.setAttribute('role', 'img'); rate.setAttribute('aria-label', rl.aria);
      var star = el('span', 'gcs-rate-s', '★'); star.setAttribute('aria-hidden', 'true');
      rate.appendChild(star); rate.appendChild(document.createTextNode(' ' + rl.text)); c.appendChild(rate);
    }
    if (opts.src) { var src_ = el('p', 'gcs-src gcs-src-' + opts.src.kind, opts.src.text); src_.title = opts.src.text; c.appendChild(src_); }
    if (opts.note) c.appendChild(el('p', 'gcs-note', opts.note));
    if (notes) c.appendChild(notes.panel);
    if (!match || !match.key || !match.in_stock) { c.appendChild(el('p', 'gcs-ask', 'Ask your rep')); return c; }
    var key = match.key;
    cards[key] = {name: name, image: src};
    c.dataset.key = key;
    var ctrl = el('div', 'gcs-ctrl');
    var minus = el('button', 'gcs-btn gcs-btn--ghost gcs-minus'); minus.type = 'button'; minus.setAttribute('aria-label', 'Remove one ' + name); minus.appendChild(icon('minus'));
    var count = el('span', 'gcs-count', '0');
    var add = el('button', 'gcs-btn gcs-btn--ghost gcs-add', 'Add'); add.type = 'button'; add.setAttribute('aria-label', 'Add ' + name + ' to your 4-pack');
    minus.addEventListener('click', function () {
      tray = L.removeCan(tray, key); flying = {};
      render();
      if (L.countOf(tray, key) === 0) add.focus();
    });
    add.addEventListener('click', function () {
      var before = tray.length;
      tray = L.addCan(tray, key);
      if (tray.length === before) return;
      track('samples_first_selected', {}, true);
      if (tray.length === L.MAX) track('samples_four_selected', {}, true);
      if (reduceMotion()) { render(); return; }
      restart(img, 'gcs-bounce');
      flying[before] = true;
      render();
      flyToTray(tile, before);
    });
    ctrl.appendChild(minus); ctrl.appendChild(count); ctrl.appendChild(add);
    c.appendChild(ctrl);
    return c;
  }

  // ---- info tasting notes + sales sheet (public sales-sheet feed; nothing shown that the feed doesn't have) ----
  var notesIdx = null;
  var openNotes = null;   // {toggle, panel} — one panel open at a time
  var notesSeq = 0;
  var notesSent = {};
  function closeNotes() {
    if (!openNotes) return;
    openNotes.panel.hidden = true; openNotes.toggle.setAttribute('aria-expanded', 'false');
    openNotes = null;
  }
  function notesPanel(nc, name) {
    var id = 'gcs-notes-' + (++notesSeq);
    var toggle = el('button', 'gcs-info'); toggle.type = 'button';
    toggle.setAttribute('aria-label', 'Tasting notes for ' + name); toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-controls', id);
    toggle.appendChild(icon('info', 22));
    var panel = el('div', 'gcs-notes'); panel.id = id; panel.hidden = true;
    if (nc.blurb) panel.appendChild(el('p', 'gcs-notes-blurb', nc.blurb));
    if (nc.facts) panel.appendChild(el('p', 'gcs-notes-facts', nc.facts));
    if (nc.sheet) {
      var a = el('a', null, 'Sales sheet →'); a.href = nc.sheet; a.target = '_blank'; a.rel = 'noopener';
      a.setAttribute('aria-label', 'Sales sheet for ' + name + ' (opens in a new tab)');
      a.addEventListener('click', function () { track('samples_sales_sheet_clicked'); });
      panel.appendChild(a);
    }
    var me = {toggle: toggle, panel: panel};
    toggle.addEventListener('click', function () {
      if (openNotes === me) { closeNotes(); return; }
      closeNotes();
      panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); openNotes = me;
      if (!notesSent[name]) { notesSent[name] = 1; track('samples_notes_opened', {has_sheet: !!nc.sheet}); }
    });
    return me;
  }
  document.addEventListener('keydown', function (ev) {
    if ((ev.key === 'Escape' || ev.key === 'Esc') && openNotes) { var t = openNotes.toggle; closeNotes(); t.focus(); }
  });
  // Fetched once, in parallel with the samples lookup; the grid never waits for it.
  var NOTES_FEED = 'https://us-central1-packaging-database.cloudfunctions.net/getPublicDistributorLeadsHttp/api/sales-sheet/beers';
  fetchJson(NOTES_FEED).then(function (r) {
    if (!r.ok) return;
    notesIdx = L.notesIndex(r.json);
    if (samplesLoaded) renderGrid(true);   // add the info buttons to cards already on screen
  }).catch(function () {});

  function render() {
    save();
    document.querySelectorAll('.gcs-card[data-key]').forEach(function (c) {
      var n = L.countOf(tray, c.dataset.key);
      c.classList.toggle('is-in', n > 0);
      var count = c.querySelector('.gcs-count'), minus = c.querySelector('.gcs-minus'), add = c.querySelector('.gcs-add');
      count.textContent = String(n); count.hidden = n === 0;
      minus.hidden = n === 0;
      // "Add" in words until the first can; then the Lucide plus (the aria-label always names the beer).
      if (n > 0 && !add.querySelector('svg')) { add.textContent = ''; add.appendChild(icon('plus')); }
      else if (n === 0 && add.querySelector('svg')) add.textContent = 'Add';
      add.disabled = tray.length >= L.MAX;
    });
    var slotsEl = $('gcs-slots'); slotsEl.textContent = '';
    L.slots(tray).forEach(function (k, i) {
      var s = el('span', 'gcs-slot' + (k ? ' is-full' : '') + (k && flying[i] ? ' is-landing' : ''));
      if (k && cards[k] && cards[k].image) { var im = el('img'); im.alt = ''; im.src = cards[k].image; s.appendChild(im); }
      slotsEl.appendChild(s);
    });
    setMsg(false);
    $('gcs-help').textContent = samplesLoaded ? L.ctaHelp(tray.length) : 'Loading the beers…';
    $('gcs-open').disabled = !samplesLoaded || tray.length === 0;
  }

  function fetchJson(url, opts) { return fetch(url, opts).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return {ok: r.ok, status: r.status, json: j || {}}; }); }); }

  // ---- the one sample grid: every beer on the page, labelled distributor / online only ----
  // Judge.me rating per Shopify handle (distributor tiles borrow the handle of the same sample key).
  var ratingByHandle = {};
  data.botm.concat(data.direct, data.prospect).forEach(function (p) { if (p.handle && p.rating && !ratingByHandle[p.handle]) ratingByHandle[p.handle] = p.rating; });
  var tiles = [];        // {name, handle, image, tags, published_at, note, match, label, botm, distIdx}
  var distLabel = '';    // the distributor's name, for the filter chip
  var distShortName = ''; // "Lakeshore" for "Lakeshore Beverage" — the availability labels
  var hasDist = false;   // a distributor is known AND at least one tile is theirs
  var sortMode = 'popular';
  var filterMode = 'all';
  function renderGrid(quiet) {
    var grid = $('gcs-grid');
    openNotes = null;   // a re-render replaces every card (and any open panel)
    grid.textContent = '';
    var mode = hasDist ? filterMode : 'all';
    var list = L.orderTiles(tiles, mode, sortMode, data.popular_rank);
    list.forEach(function (t, i) {
      // Only say "Online only" when we actually know what their distributor carries (hasDist) — otherwise "Available online".
      var avail = L.availabilityLabel(t.label === 'dist', t.online, hasDist ? distShortName : '');
      grid.appendChild(card(t, t.match, {
        eager: i < 8, rating: ratingByHandle[t.handle] || null,   // the first two rows paint straight away — never an empty can panel
        tag: t.botm ? 'This month' : '', note: t.note, style: t.style, notes: L.notesContent(L.notesFor(t, notesIdx)),
        src: {kind: t.label === 'dist' ? 'dist' : 'online', text: avail}
      }));
    });
    // Only a filter can empty the grid on purpose; on All the samples-unavailable notice already explains.
    $('gcs-empty').hidden = list.length > 0 || !samplesLoaded || mode === 'all';
    $('gcs-filter').hidden = !hasDist;
    // Sort only reorders the non-distributor tiles — hide it unless at least 2 of them are in view.
    $('gcs-sort').hidden = !L.sortUseful(list);
    render();
  }
  function pressGroup(group, attr, btn) {
    group.querySelectorAll('button[' + attr + ']').forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
  }
  $('gcs-sort').addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('button[data-sort]');
    if (!b || b.dataset.sort === sortMode) return;
    sortMode = b.dataset.sort; pressGroup($('gcs-sort'), 'data-sort', b);
    renderGrid();
  });
  function setFilter(mode) {
    if (mode === filterMode) return;
    filterMode = mode;
    pressGroup($('gcs-filter'), 'data-filter', $('gcs-filter').querySelector('button[data-filter="' + mode + '"]'));
    if (samplesLoaded) renderGrid();   // before the lookup lands, build() renders with this filter
  }
  $('gcs-filter').addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('button[data-filter]');
    if (b) setFilter(b.dataset.filter);
  });
  // Scroll to the selector heading (its scroll-margin-top clears the sticky campaign header) and move focus there.
  function toSelector() {
    var h = $('gcs-h-samples');
    h.scrollIntoView({behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start'});
    try { h.focus({preventScroll: true}); } catch (e) { h.focus(); }
  }
  $('gcs-hero-cta').addEventListener('click', function (ev) { ev.preventDefault(); track('samples_hero_cta_clicked', {where: 'hero'}); toSelector(); });
  // "Why Go →" (hero ghost): to the Why Go (proof) section.
  $('gcs-why-go').addEventListener('click', function (ev) {
    ev.preventDefault();
    track('samples_why_go_clicked');
    var t = $('gcs-sec-proof');
    t.scrollIntoView({behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start'});
    try { t.focus({preventScroll: true}); } catch (e) { t.focus(); }
  });
  // ---- bars & restaurants offer: the post-claim next step and the "Two ways to order" shipping row (same rule) ----
  function setOffer(on) {
    $('gcs-next-offer').hidden = !on;
    $('gcs-ways-ship').hidden = !on;
    document.querySelectorAll('.gcs-ways-shipm').forEach(function (x) { x.hidden = !on; });
  }
  // ---- "Two ways to order": with a known distributor (venue API, else the URL — same rule as the grid) the
  // "Find my distributor" link becomes the plain text "Your rep: {distributor}". Text only. ----
  function paintWays(distName) {
    var d = String(distName || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    document.querySelectorAll('.gcs-ways-find').forEach(function (x) { x.hidden = !!d; });
    // Known distributor: say who it is — the column head, the "you order from" cell and one bold line.
    document.querySelectorAll('.gcs-ways-rep').forEach(function (x) { x.hidden = !d; x.textContent = d ? d + ' is your distributor' : ''; });
    document.querySelectorAll('.gcs-ways-eye').forEach(function (x) { x.hidden = !d; });
    document.querySelectorAll('.gcs-ways-dname').forEach(function (x) { x.textContent = d || 'Your distributor'; });
    document.querySelectorAll('.gcs-ways-from').forEach(function (x) { x.textContent = d ? 'Your ' + d + ' rep' : 'The rep you already buy from'; });
  }
  $('gcs-ways-cta').addEventListener('click', function (ev) { ev.preventDefault(); track('samples_hero_cta_clicked', {where: 'two_ways', source: 'two_ways'}); toSelector(); });
  document.querySelectorAll('.gcs-ways-find').forEach(function (x) { x.addEventListener('click', function () { trackBeforeLeaving('samples_find_distributor_clicked', {source: 'two_ways'}); }); });
  // The cream announcement bar's link (snippets/go-campaign-header.liquid) jumps to the Untappd table.
  var annLink = document.querySelector('[data-gch-ann]');
  if (annLink) annLink.addEventListener('click', function () { track('samples_announcement_clicked'); });

  // ---- online wholesale: one-click (email token) | "Get approved" (claim key) | received | set up | link (last resort) ----
  var NEEDS = ['contact_name', 'street', 'city', 'state', 'zip', 'phone'];
  var safeUrl = function (u) { return typeof u === 'string' && /^https:\/\/[^\s"'<>]+$/.test(u) ? u : null; };
  var qs = new URLSearchParams(); if (P.t) qs.set('t', P.t); Object.keys(P.utm).forEach(function (k) { qs.set(k, P.utm[k]); });
  var applyUrl = (function () { var u = data.wholesaleUrl || '/pages/wholesale-apply'; return qs.toString() ? u + (u.indexOf('?') < 0 ? '?' : '&') + qs.toString() : u; })();
  var lastClaimStatus = '';   // status of the confirmed claim (ok | pending_approval | already_claimed)
  // The claim answer's one-time {claim_id, ws_key}: IN MEMORY ONLY — never the URL, never storage. It lets the
  // visitor ask for online wholesale with what they just sent (no second form).
  var claimKey = null;
  var claimWs = null;        // L.claimWsOutcome(...) once "Get approved" answered
  function wsMode() {
    return L.wholesaleMode({w: venueInfo && venueInfo.wholesale, hasToken: !!P.t, claimStatus: lastClaimStatus, claimKey: !!claimKey, claimWs: claimWs});
  }
  // ---- the post-claim "next step" (inside the claim dialog's done view) ----
  var lastClaim = null;      // what they just submitted — the prefill source for one-click wholesale
  var justApproved = null;   // {email} once a signup from this page succeeded
  var distNameCur = '';      // the venue's distributor (API, else URL) — same rule as everywhere on the page
  function renderNext() {
    var mode = wsMode(), w = (venueInfo && venueInfo.wholesale) || {};
    $('gcs-next-oneclick').hidden = mode !== 'oneclick';
    $('gcs-next-claim').hidden = mode !== 'claim';
    $('gcs-next-received').hidden = mode !== 'submitted';
    $('gcs-next-ok').hidden = mode !== 'approved';
    $('gcs-next-apply').hidden = mode !== 'link';
    $('gcs-next-apply').href = applyUrl;
    if (mode === 'oneclick') {
      // The account is created under the address we emailed, not the one typed in the claim — say so.
      $('gcs-next-under').hidden = !w.email;
      $('gcs-next-under').textContent = w.email ? 'Your account will be under ' + w.email + '.' : '';
      // Show what we'll send when it came from the claim (hidden fields), with an Edit to correct it first —
      // e.g. a home ship-to address that shouldn't become the business record.
      var pf = lastClaim ? L.wholesalePrefill(lastClaim, venueInfo, w.needs) : null;
      var showUsing = !!(pf && !pf.missing.length);
      $('gcs-next-using').hidden = !showUsing;
      if (showUsing) {
        var b = pf.body, parts = [b.contact_name];
        if (b.phone) parts.push(b.phone);
        if (b.street || b.city) parts.push([b.street, [b.city, b.state].filter(Boolean).join(' ')].filter(Boolean).join(', ') + (b.zip ? ' ' + b.zip : ''));
        $('gcs-next-using-t').textContent = 'Using: ' + parts.filter(Boolean).join(' · ');
      }
    }
    if (mode === 'approved') {
      $('gcs-next-okh').textContent = justApproved ? "You're approved 🍻" : "You're already set up";
      $('gcs-next-okp').hidden = !justApproved;
      $('gcs-next-okp').textContent = justApproved ? (justApproved.email ? 'Check ' + justApproved.email + ' for your sign-in link.' : 'Check your email for your sign-in link.') : '';
      $('gcs-next-login').href = safeUrl(w.login_url) || (claimWs && safeUrl(claimWs.login)) || '#';
    }
    // Step 1's one link to the wholesale step — not for a venue that's already set up. "Instant" only when it is.
    $('gcs-ws-more').hidden = mode === 'approved';
    $('gcs-ws-more').textContent = mode === 'oneclick' ? "You're eligible for an instant online wholesale account →"
      : mode === 'submitted' ? 'Online wholesale: application received →' : 'Order direct from Go with online wholesale →';
  }
  function markApproved(j) {
    var w = venueInfo.wholesale;
    var email = typeof j.email === 'string' && j.email ? j.email : w.email;
    var login = safeUrl(j.login_url) || safeUrl(w.login_url);
    w.approved = true; if (login) w.login_url = login;
    justApproved = {email: email || ''};
    track('samples_wholesale_approved', {already: !!j.already});
    renderNext();
    return {email: email, login: login};
  }

  var wdlg = $('gcs-ws-dialog'), wform = $('gcs-ws-form');
  var wsNeeds = [];
  var wsBusy = false;
  var wsFinal = false;   // 403/404: the server won't set this venue up online — no retry, even after reopening
  var WS_FINAL = "Reply to our email and we'll set you up.";
  function needField(k) { return wform.querySelector('[data-need="' + k + '"]'); }
  function showNeed(k) {
    var f = needField(k); if (!f) return;
    f.hidden = false; wform.elements[k].required = true;
    if (wsNeeds.indexOf(k) < 0) wsNeeds.push(k);
  }
  function syncStateRow() { $('gcs-ws-staterow').hidden = needField('state').hidden && needField('zip').hidden; }
  // pf = L.wholesalePrefill(...) from the claim: every needed field is prefilled (and sent), but only the ones
  // still missing are shown — so the buyer types only what we couldn't take from the claim.
  function openWs(pf, showAll) {
    if (nextBusy) return;   // the one-click POST is in flight — never start a second signup alongside it
    if (wsBusy) { if (!wdlg.open) { lockPage(); wdlg.showModal(); } return; }   // a submit is in flight — reopen as-is, don't reset
    var w = (venueInfo && venueInfo.wholesale) || {};
    wsNeeds = [];
    NEEDS.forEach(function (k) { needField(k).hidden = true; wform.elements[k].required = false; wform.elements[k].removeAttribute('aria-invalid'); wform.elements[k].removeAttribute('aria-describedby'); });
    if (pf) {
      Object.keys(pf.body).forEach(function (k) {
        if (NEEDS.indexOf(k) < 0) return;
        if (pf.values[k] && !wform.elements[k].value) wform.elements[k].value = pf.values[k];
        wsNeeds.push(k);
      });
      (showAll ? Object.keys(pf.body) : pf.missing).forEach(function (k) { showNeed(k); });
    } else {
      // A name is always needed; the rest only when the venue API says we're missing it.
      showNeed('contact_name');
      (Array.isArray(w.needs) ? w.needs : []).forEach(function (k) { if (NEEDS.indexOf(k) >= 0) showNeed(k); });
    }
    syncStateRow();
    var under = $('gcs-ws-under');
    under.hidden = !w.email; under.textContent = w.email ? 'Your account will be under ' + w.email + '.' : '';
    if (!wform.elements.contact_name.value && $('gcs-full-name').value) wform.elements.contact_name.value = $('gcs-full-name').value;
    $('gcs-ws-err').hidden = true; $('gcs-ws-submit').hidden = false; $('gcs-ws-submit').disabled = false; delete $('gcs-ws-submit').dataset.final;
    wform.hidden = false; $('gcs-ws-done').hidden = true;
    if (wsFinal) { wsError(WS_FINAL); $('gcs-ws-submit').hidden = true; $('gcs-ws-submit').disabled = true; $('gcs-ws-submit').dataset.final = '1'; }
    lockPage();
    wdlg.showModal();
  }
  function wsError(msg) { $('gcs-ws-err').textContent = msg; $('gcs-ws-err').hidden = false; }
  // Links that leave the page are tracked with sendBeacon so the event survives the navigation.
  $('gcs-next-apply').addEventListener('click', function () { trackBeforeLeaving('samples_wholesale_clicked', {mode: 'link'}); });
  // "Get instantly approved" (Two ways to order) opens the wholesale step of the sheet — the same benefits panel as
  // after a claim, with the same one-click / sign-in / apply action. No claim yet: the one-click prefills from the
  // venue API and the missing-fields dialog asks only for what's missing. The href stays as the no-JS fallback.
  function openWholesaleStep() {
    renderNext();
    form.hidden = true; $('gcs-done').hidden = false;
    showStep(2); $('gcs-ws-back').hidden = true;
    if (!dlg.open) { lockPage(); dlg.showModal(); }
    var h = $('gcs-step2-h'); try { h.focus({preventScroll: true}); } catch (e) { h.focus(); }
  }
  document.querySelectorAll('.gcs-ways-ws').forEach(function (x) {
    x.href = applyUrl;
    x.addEventListener('click', function (ev) {
      ev.preventDefault();
      track('samples_wholesale_clicked', {mode: wsMode(), source: 'two_ways'});
      openWholesaleStep();
    });
  });
  $('gcs-next-login').addEventListener('click', function () { trackBeforeLeaving('samples_wholesale_clicked', {mode: 'signin'}); });
  // "Get instantly approved": prefilled from the claim; posts straight away when nothing is missing,
  // otherwise opens the wholesale dialog showing only the missing fields.
  var nextBusy = false;
  function nextError(msg) { $('gcs-next-err').textContent = msg; $('gcs-next-err').hidden = false; }
  $('gcs-next-approve').addEventListener('click', function () {
    if (nextBusy || wsBusy) return;
    track('samples_wholesale_clicked', {mode: 'one_click'});
    var w = (venueInfo && venueInfo.wholesale) || {};
    var pf = L.wholesalePrefill(lastClaim, venueInfo, w.needs);
    $('gcs-next-err').hidden = true;
    if (wsFinal) { nextError(WS_FINAL); return; }
    // Missing fields open the dialog — unless this page never saw the claim (e.g. the 7-day follow-up link): then the
    // server fills them from the venue's claim and a 400 asks for exactly what it still lacks.
    if (pf.missing.length && lastClaim) { openWs(pf); return; }   // stacked on top of the claim dialog — cancelling returns here
    var btn = this; nextBusy = true; btn.disabled = true; btn.textContent = 'Approving…'; $('gcs-next-edit').disabled = true;
    var settle = function () { nextBusy = false; btn.disabled = false; btn.textContent = 'Get instantly approved'; $('gcs-next-edit').disabled = false; };
    var body = {t: P.t}; Object.keys(pf.body).forEach(function (k) { body[k] = pf.body[k]; });
    fetchJson(data.api + '/api/crm/wholesale-signup', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)})
      .then(function (r) {
        var j = r.json;
        if (r.ok && (j.ok || j.already)) { markApproved(j); var l = $('gcs-next-login'); if (!$('gcs-next-ok').hidden) l.focus(); return; }
        if (r.status === 400 && Array.isArray(j.missing) && j.missing.length) {
          // The server wants something we couldn't prefill (or it didn't validate) — ask for exactly that.
          settle();   // this request is over — the dialog's own submit takes it from here
          pf.missing = j.missing.filter(function (k) { return NEEDS.indexOf(k) >= 0; });
          j.missing.forEach(function (k) { if (NEEDS.indexOf(k) >= 0 && !(k in pf.body)) pf.body[k] = ''; });
          openWs(pf);
          pf.missing.forEach(function (k) { var inp = wform.elements[k]; inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('aria-describedby', 'gcs-ws-err'); });
          wsError('Please check the highlighted fields.');
          if (pf.missing[0]) wform.elements[pf.missing[0]].focus();
          return;
        }
        if (r.status === 403 || r.status === 404) { wsFinal = true; nextError(WS_FINAL); btn.hidden = true; $('gcs-next-using').hidden = true; $('gcs-next-err').focus(); return; }
        nextError('Something went wrong. Try again?'); $('gcs-next-err').focus();
      })
      .catch(function () { nextError('Something went wrong. Try again?'); $('gcs-next-err').focus(); })
      .then(settle);
  });
  // "Get approved" with the claim's one-time key: the application is built from the claim — no form, no external link.
  var claimBusy2 = false;
  function claimErr(msg) { var e = $('gcs-next-claim-err'); e.textContent = msg; e.hidden = !msg; if (msg) e.focus(); }
  $('gcs-next-claimbtn').addEventListener('click', function () {
    if (claimBusy2 || !claimKey) return;
    track('samples_wholesale_clicked', {mode: 'claim'});
    var btn = this; claimBusy2 = true; btn.disabled = true; btn.textContent = 'Sending…'; claimErr('');
    fetchJson(data.api + '/api/crm/wholesale-signup', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({claim_id: claimKey.claim_id, ws_key: claimKey.ws_key})})
      .then(function (r) {
        if (!r.ok && (r.status === 429 || r.status >= 500)) { claimErr('Something went wrong. Try again?'); return; }
        claimWs = L.claimWsOutcome(r.ok, r.json);
        if (claimWs.result === 'approved') { justApproved = {email: claimWs.email || ''}; track('samples_wholesale_approved', {via: 'claim'}); }
        else if (claimWs.result === 'submitted') track('samples_wholesale_submitted', {via: 'claim'});
        renderNext();
        if (claimWs.result === 'fallback') { $('gcs-next-apply').focus(); return; }
        var t = claimWs.result === 'approved' ? $('gcs-next-login') : $('gcs-next-received-h');
        try { t.focus({preventScroll: true}); } catch (e) { t.focus(); }
      })
      .catch(function () { claimErr('Something went wrong. Try again?'); })
      .then(function () { claimBusy2 = false; btn.disabled = false; btn.textContent = 'Get approved'; });
  });
  $('gcs-ws-cancel').addEventListener('click', function () { wdlg.close(); });
  $('gcs-ws-done-close').addEventListener('click', function () { wdlg.close(); });
  // Opened on top of the claim dialog (next step)? Return focus there, so the offer is still one click away.
  wdlg.addEventListener('close', function () {
    if (dlg.open) {
      var t = !$('gcs-next-ok').hidden ? $('gcs-next-login') : !$('gcs-next-approve').hidden && !$('gcs-next-oneclick').hidden ? $('gcs-next-approve') : $('gcs-done-close');
      t.focus(); return;
    }
    unlockPage();
    focusBack();
  });
  $('gcs-next-edit').addEventListener('click', function () {
    var w = (venueInfo && venueInfo.wholesale) || {};
    openWs(L.wholesalePrefill(lastClaim, venueInfo, w.needs), true);
  });
  wform.addEventListener('input', function (ev) { if (ev.target && ev.target.removeAttribute) { ev.target.removeAttribute('aria-invalid'); ev.target.removeAttribute('aria-describedby'); } });
  wform.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var btn = $('gcs-ws-submit');
    if (wsBusy || nextBusy || btn.disabled) return;
    wsBusy = true; $('gcs-next-approve').disabled = true;   // no one-click POST while this one is in flight
    var body = {t: P.t};
    wsNeeds.forEach(function (k) { var v = String(wform.elements[k].value || '').trim(); body[k] = k === 'state' ? v.toUpperCase() : v; });
    btn.disabled = true; btn.textContent = 'Setting you up…';
    $('gcs-ws-err').hidden = true;
    fetchJson(data.api + '/api/crm/wholesale-signup', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)})
      .then(function (r) {
        var j = r.json;
        if (r.ok && (j.ok || j.already)) {
          var got = markApproved(j), email = got.email, login = got.login;
          $('gcs-ws-done-p').textContent = email ? 'Check ' + email + ' for your sign-in link.' : 'Check your email for your sign-in link.';
          $('gcs-ws-login').hidden = !login; if (login) $('gcs-ws-login').href = login;
          wform.hidden = true; $('gcs-ws-done').hidden = false;
          ($('gcs-ws-login').hidden ? $('gcs-ws-done-close') : $('gcs-ws-login')).focus();
          return;
        }
        if (r.status === 400 && Array.isArray(j.missing) && j.missing.length) {
          var first = null;
          j.missing.forEach(function (k) {
            if (NEEDS.indexOf(k) < 0) return;
            showNeed(k);
            var inp = wform.elements[k];
            inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('aria-describedby', 'gcs-ws-err');
            if (!first) first = inp;
          });
          syncStateRow();
          wsError('Please check the highlighted fields.');
          if (first) focusField(first);
          return;
        }
        if (r.status === 403 || r.status === 404) { wsFinal = true; wsError(WS_FINAL); btn.hidden = true; btn.dataset.final = '1'; return; }
        wsError('Something went wrong. Try again?');
      })
      .catch(function () { wsError('Something went wrong. Try again?'); })
      .then(function () { wsBusy = false; $('gcs-next-approve').disabled = false; btn.disabled = !!btn.dataset.final; btn.textContent = 'Get my wholesale account'; });
  });

  // ---- build: venue answer → one samples lookup for every name on the page → sections ----
  function lookup(items) {
    var seen = {}, qsList = [];
    items.forEach(function (b) {
      var n = lookupName(b); if (!n) return;
      var q = n + (b.handle ? '|' + b.handle : '');
      if (seen[q]) return; seen[q] = 1; qsList.push(q);
    });
    // The API reads at most 40 names per request, so a full catalog goes in a few batches.
    var batches = [];
    for (var i = 0; i < qsList.length; i += 40) batches.push(qsList.slice(i, i + 40));
    if (!batches.length) return Promise.resolve(true);
    return Promise.all(batches.map(function (b) {
      return fetchJson(data.api + '/api/crm/samples?' + b.map(function (q) { return 'n=' + encodeURIComponent(q); }).join('&')).catch(function () { return {ok: false, json: {}}; });
    })).then(function (rs) {
      rs.forEach(function (r) { ((r.json && r.json.matches) || []).forEach(function (m) { if (m && typeof m.name === 'string' && !byName[m.name]) byName[m.name] = m; }); });
      return rs.every(function (r) { return r.ok; });
    });
  }

  function build(v) {
    venueInfo = v;
    greet(v);
    setOffer(L.showBarsOffer(v, P));
    // v is the venue API's answer (falsy only when there's no token, a 404, or the fetch failed);
    // once it answered, trust its distributor field even when null — never fall back to the URL param.
    var distName = v ? v.distributor : P.distributor;
    var distBeers = (v && v.beers_available && v.beers_available.length ? v.beers_available : P.beers.map(function (n) { return {name: n, image: null}; }));
    var seasonal = (v && v.seasonal) || [];
    var seasonalMapped = seasonal.map(function (s) { return {name: s.name, image: s.image, note: s.note}; });
    var dist = distName ? distBeers : [];
    distShortName = distName ? L.distShort(distName) : '';
    distNameCur = distName || '';
    paintWays(distName);
    renderNext();
    // Dedupe order matters: the first copy of a beer wins its name/handle/tags. Distributor beers first (their
    // label), then This month, then the beers collection (it has handles, tags and dates for sorting), then
    // prospect + seasonal (a seasonal note still joins the same-key card — see L.dedupeByKey).
    var mark = function (list, f) { return list.map(function (x, i) { var c = {}; Object.keys(x).forEach(function (k) { c[k] = x[k]; }); c[f] = i; return c; }); };
    var all = [].concat(mark(dist, '_dist'), mark(data.botm, '_botm'), data.direct, data.prospect, seasonalMapped);
    return lookup(all).then(function (ok) {
      if (!ok) { var u = $('gcs-unavail'); if (u) { u.textContent = 'Samples are unavailable right now — try again in a few minutes.'; u.hidden = false; } }
      // Each distributor key → its position in the ORIGINAL distributor list (their best-seller order).
      var distKeyIdx = {};
      dist.forEach(function (b, i) { var k = keyOf(b); if (k && !Object.prototype.hasOwnProperty.call(distKeyIdx, k)) distKeyIdx[k] = i; });
      var botmKeys = data.botm.map(keyOf).filter(Boolean);
      // Distributor tiles (venue API) have no Shopify handle — borrow the handle of the Shopify item with the same
      // sample key, so the info feed matches by handle (name matching stays only as a last fallback).
      var handleOfKey = L.handlesByKey(data.botm.concat(data.direct, data.prospect), keyOf);
      // Sold online = in the online-wholesale collections (This month + beers), by sample key or Shopify handle.
      var onlineKeys = {}, onlineHandles = {}, styleByKey = {};
      data.botm.concat(data.direct).forEach(function (p) { var k = keyOf(p); if (k) onlineKeys[k] = 1; if (p.handle) onlineHandles[p.handle] = 1; });
      all.forEach(function (p) { var k = keyOf(p), st = L.styleOf(p.name); if (k && st && !styleByKey[k]) styleByKey[k] = st; });
      var botmNames = data.botm.map(function (b) { return L.nameKey(b.name); });
      distLabel = distName || '';
      tiles = [];
      L.dedupeByKey(all, keyOf).forEach(function (t) {
        var m = matchOf(t), key = (m && m.key) || null;
        var nk = L.nameKey(t.name);
        // A keyless distributor beer is still theirs (matched by its own name); keyed tiles are labelled by key.
        var src = distName ? L.tileSource(key, distKeyIdx, typeof t._dist === 'number' ? t._dist : null) : {label: 'online', distIdx: null};
        var isDist = src.label === 'dist';
        var buyable = !!(m && key && m.in_stock);
        if (!buyable && !isDist) return;   // nothing to add and nothing to order here
        tiles.push({name: t.name, handle: t.handle || (key && handleOfKey[key]) || null, image: t.image, tags: t.tags, published_at: t.published_at, note: t.note, match: m,
          label: isDist ? 'dist' : 'online', distIdx: src.distIdx, botm: key ? botmKeys.indexOf(key) >= 0 : botmNames.indexOf(nk) >= 0,
          online: !!((key && onlineKeys[key]) || (t.handle && onlineHandles[t.handle])),
          style: L.styleOf(t.name) || (key && styleByKey[key]) || ''});
        if (buyable) cards[key] = {name: displayName(t.name), image: t.image || m.image || ''};
      });
      hasDist = !!distName && tiles.some(function (t) { return t.label === 'dist'; });
      if (hasDist) $('gcs-filter-dist').textContent = distName;
      samplesLoaded = true;
      renderGrid();
      // Only now is every tile known (including ones hidden by a filter) — restore the saved tray against all of them.
      tray = L.restoreTray(tray, Object.keys(cards));
      render();
    });
  }


  // ---- "What drinkers say": real 5-star reviews of the beers on this page (cached Judge.me file) ----
  // Fetched lazily (when the section is within ~600px of the viewport) so it never competes with the first paint
  // or the CTA. On failure or no matches: the summary line stays, no cards, no error text.
  function loadReviews() {
    var box = $('gcs-rv-cards');
    if (!box) return;
    var started = false;
    var go = function () {
      if (started) return; started = true;
      var src = box.getAttribute('data-src');
      if (!src) return;
      box.hidden = false; box.classList.add('is-loading');   // hold the space so nothing below jumps
      var none = function () { box.classList.remove('is-loading'); box.hidden = true; };
      fetchJson(src).then(function (r) {
        if (!r.ok || !Array.isArray(r.json)) return none();
        var handles = data.botm.concat(data.direct, data.prospect).map(function (p) { return p.handle; });
        var picked = L.pickReviews(r.json, handles, 6);
        if (!picked.length) return none();
        box.textContent = '';
        picked.forEach(function (x) {
          var c = el('figure', 'gcs-rv-card'); c.setAttribute('role', 'listitem');
          var st = el('p', 'gcs-rv-card-stars', '★★★★★'); st.setAttribute('role', 'img'); st.setAttribute('aria-label', '5 out of 5 stars'); c.appendChild(st);
          var title = L.reviewTitle(x);   // not when it only repeats the product name
          if (title) c.appendChild(el('p', 'gcs-rv-card-t', title));
          c.appendChild(el('blockquote', 'gcs-rv-card-b', String(x.b).trim()));
          var by = el('figcaption', 'gcs-rv-card-by', '— ' + String(x.n || 'A Go Brewing customer').trim() + (x.p ? ', on ' + displayName(x.p) : ''));
          if (x.v) by.appendChild(el('span', 'gcs-rv-card-v', 'Verified buyer'));
          c.appendChild(by);
          box.appendChild(c);
        });
        box.classList.remove('is-loading');
      }).catch(none);
    };
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { o.disconnect(); go(); } }, {rootMargin: '600px 0px'});
      o.observe(box.closest('section') || box);
    } else {
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
    }
  }

  // ---- claim sheet ----
  var dlg = $('gcs-dialog'), form = $('gcs-form');
  function syncMode() {
    var fedex = form.mode.value !== 'rep';
    $('gcs-ship').hidden = !fedex;
    $('gcs-mode-help').textContent = fedex ? 'Free FedEx, next business day.' : 'Your rep drops them off.';
  }
  // ---- sheets: the page behind an open dialog is scroll-locked and restored to the exact same place on close ----
  var lockY = null;
  function lockPage() {
    if (lockY !== null) return;
    lockY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
  }
  function unlockPage() {
    if (lockY === null) return;
    var y = lockY; lockY = null;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.overflow = '';
    window.scrollTo(0, y);
  }
  // Focus goes back to the tray's Continue (else the page heading) WITHOUT scrolling — no jump to the top.
  function focusBack() {
    var t = !$('gcs-open').disabled ? $('gcs-open') : $('gcs-hello');
    if (!t) return;
    try { t.focus({preventScroll: true}); } catch (e) { t.focus(); }
  }
  // The sheet's ✕ (top bar) closes its own dialog.
  document.querySelectorAll('[data-gcs-close]').forEach(function (b) { b.addEventListener('click', function () { var d = b.closest('dialog'); if (d && d.open) d.close(); }); });
  // Bring a field into view above the sticky action bar, then focus it.
  function focusField(el) {
    if (!el) return;
    try { el.scrollIntoView({block: 'center', behavior: reduceMotion() ? 'auto' : 'smooth'}); } catch (e) {}
    try { el.focus({preventScroll: true}); } catch (e) { el.focus(); }
  }
  // However the dialog closes — Esc, Cancel, Done, or the browser's own dismissal — move focus
  // somewhere sensible. #gcs-open may be disabled (no cans picked), so the page heading is the
  // one control that's always focusable.
  dlg.addEventListener('close', function () { if (!wdlg.open) { unlockPage(); focusBack(); } });
  $('gcs-open').addEventListener('click', function () {
    var distName = (venueInfo && venueInfo.distributor) || '';
    // The toggle only exists when a distributor is known — the claim API refuses rep mode without one.
    $('gcs-seg').hidden = !distName;
    $('gcs-rep-label').textContent = (distName ? L.distShort(distName) : 'My') + ' rep brings them';
    if (!distName) form.mode.value = 'fedex';
    var picked = {}; tray.forEach(function (k) { if (cards[k]) picked[k] = (picked[k] || 0) + 1; });
    // The picked cans as small thumbnails (alt = the beer's name), then the count.
    var pk = $('gcs-picked'); pk.textContent = '';
    tray.forEach(function (k) {
      var c = cards[k]; if (!c) return;
      var li = el('li'); var im = el('img'); im.alt = c.name; im.width = 44; im.height = 44;
      if (c.image) im.src = c.image; else { li.textContent = c.name.slice(0, 2); }
      if (c.image) li.appendChild(im); pk.appendChild(li);
    });
    var cnt = el('li', 'gcs-picked-n', tray.length + (tray.length === 1 ? ' can' : ' cans')); pk.appendChild(cnt);
    // Carry over everything we know (venue API + URL); every field stays editable, and anything already typed wins.
    var pre = L.claimPrefill(venueInfo, P);
    Object.keys(pre).forEach(function (k) { if (form.elements[k] && !form.elements[k].value) form.elements[k].value = pre[k]; });
    $('gcs-err').hidden = true; form.hidden = false; $('gcs-done').hidden = true;
    syncMode();
    clearFieldErrors();
    track('samples_request_started', {cans: tray.length}, true);
    lockPage();
    dlg.showModal();
  });
  form.addEventListener('change', syncMode);
  $('gcs-cancel').addEventListener('click', function () { dlg.close(); });
  $('gcs-done-close').addEventListener('click', function () { dlg.close(); });
  // ---- done view: step 1 (thank you) ⇄ step 2 (online wholesale benefits + the existing action) ----
  function showStep(n) {
    $('gcs-step1').hidden = n !== 1; $('gcs-step2').hidden = n !== 2;
    var d = $('gcs-done'); if (d) d.scrollTop = 0;
  }
  $('gcs-ws-more').addEventListener('click', function () {
    showStep(2);
    track('samples_wholesale_benefits_opened', {mode: wsMode()});
    var h = $('gcs-step2-h'); try { h.focus({preventScroll: true}); } catch (e) { h.focus(); }
  });
  $('gcs-ws-back').addEventListener('click', function () {
    showStep(1);
    var l = $('gcs-ws-more'); try { l.focus({preventScroll: true}); } catch (e) { l.focus(); }
  });
  // Errors show next to their field (aria-invalid + aria-describedby); typed values are never cleared.
  var FIELDS = ['full_name', 'email', 'phone', 'company', 'address1', 'city', 'province', 'zip'];
  function clearFieldErrors() {
    FIELDS.forEach(function (k) { var i = form.elements[k], e = $('gcs-e-' + k); i.removeAttribute('aria-invalid'); i.removeAttribute('aria-describedby'); e.hidden = true; e.textContent = ''; });
  }
  function showFieldError(k, msg) {
    var i = form.elements[k], e = $('gcs-e-' + k);
    e.textContent = msg; e.hidden = false; i.setAttribute('aria-invalid', 'true'); i.setAttribute('aria-describedby', 'gcs-e-' + k);
  }
  form.addEventListener('input', function (ev) {
    var k = ev.target && ev.target.name;
    if (FIELDS.indexOf(k) >= 0 && ev.target.getAttribute('aria-invalid')) { ev.target.removeAttribute('aria-invalid'); ev.target.removeAttribute('aria-describedby'); $('gcs-e-' + k).hidden = true; }
  });
  var claimBusy = false;
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (claimBusy) return;
    var mode = form.mode.value === 'rep' ? 'rep' : 'fedex';
    clearFieldErrors(); $('gcs-err').hidden = true;
    var vals = {}; FIELDS.forEach(function (k) { vals[k] = form.elements[k].value; });
    var errs = L.validateClaim(vals, mode, !!P.t), bad = FIELDS.filter(function (k) { return errs[k]; });
    if (bad.length) {
      bad.forEach(function (k) { showFieldError(k, errs[k]); });
      $('gcs-err').textContent = bad.length === 1 ? 'Please fix the highlighted field.' : 'Please fix the ' + bad.length + ' highlighted fields.';
      $('gcs-err').hidden = false;
      focusField(form.elements[bad[0]]);
      return;
    }
    claimBusy = true;
    var btn = $('gcs-submit'); btn.disabled = true; btn.textContent = 'Sending…';
    var counts = {}; tray.forEach(function (k) { counts[k] = (counts[k] || 0) + 1; });
    var body = {
      t: P.t || undefined, utm: P.utm, hp: form.hp.value, mode: mode,
      items: Object.keys(counts).map(function (k) { return {key: k, qty: counts[k]}; }),
      buyer: {name: form.full_name.value, role: form.role.value, email: form.email.value, phone: form.phone.value},
      ship_to: mode === 'fedex' ? {name: form.full_name.value, company: form.company.value, address1: form.address1.value, address2: form.address2.value, city: form.city.value, province: form.province.value, zip: form.zip.value} : null,
    };
    // For Brewery OS's server-side Meta Lead: this page, the _fbp / _fbc cookies, an fbclid, and whether the visitor
    // opted out of sharing (Shopify "do not sell or share" or Global Privacy Control). The server drops `t` / `venue`.
    var ck = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } };
    var optOut = false;
    try { optOut = navigator.globalPrivacyControl === true || !!(window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.saleOfDataAllowed === 'function' && Shopify.customerPrivacy.saleOfDataAllowed() === false); } catch (e) {}
    body.page_url = location.href; body.fbp = ck('_fbp'); body.fbc = ck('_fbc'); body.capi_opt_out = optOut;
    try { body.fbclid = new URLSearchParams(location.search).get('fbclid') || ''; } catch (e) { body.fbclid = ''; }
    fetchJson(data.api + '/api/crm/claim', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)})
      .then(function (r) {
        var st = r.json && r.json.status;
        // Success only on a confirmed answer from Brewery OS — anything else is an error, and the form keeps its values.
        if (!r.ok || ['ok', 'pending_approval', 'already_claimed'].indexOf(st) < 0) {
          var msg = (r.json && typeof r.json.error === 'string' && r.json.error) || (r.status === 429 ? 'Too many tries — give it a few minutes.' : 'Something went wrong. Try again?');
          var fk = L.fieldForServerError(msg);
          if (fk && (mode === 'fedex' || ['address1', 'city', 'province', 'zip'].indexOf(fk) < 0)) { showFieldError(fk, msg); focusField(form.elements[fk]); }
          $('gcs-err').textContent = msg;
          $('gcs-err').hidden = false;
          return;
        }
        track('samples_request_submitted', {status: st, mode: body.mode, cans: body.items.reduce(function (a, i) { return a + i.qty; }, 0)});
        // The one-click wholesale next step prefills from exactly what they just confirmed.
        lastClaimStatus = st;
        claimKey = L.claimKeyOf(r.json); claimWs = null;   // memory only
        lastClaim = {mode: body.mode, full_name: vals.full_name, phone: vals.phone,
          ship: body.ship_to ? {address1: body.ship_to.address1, city: body.ship_to.city, province: body.ship_to.province, zip: body.ship_to.zip} : null};
        renderNext();
        var repName = venueInfo && venueInfo.distributor ? L.distShort(venueInfo.distributor) + ' rep' : 'rep';
        // Step 1 is just a thank-you and one line. A claim waiting on approval has not shipped — never say it has.
        $('gcs-done-h').textContent = 'Thank you 🍻';
        $('gcs-done-p').textContent = st === 'already_claimed' ? 'We already have a sample request for you.'
          : st === 'pending_approval' ? (body.mode === 'rep' ? 'We\'ll let your ' + repName + ' know once it\'s approved.' : 'We\'ll ship them by FedEx once it\'s approved.')
          : body.mode === 'rep' ? 'Your ' + repName + ' will bring them by.' : 'Your samples ship next business day by FedEx.';
        showStep(1); $('gcs-ws-back').hidden = false;
        form.hidden = true; $('gcs-done').hidden = false;
        tray = []; flying = {}; render();
      })
      .catch(function () { $('gcs-err').textContent = 'We couldn\'t reach our server. Check your connection and try again.'; $('gcs-err').hidden = false; })
      .then(function () { claimBusy = false; btn.disabled = false; btn.textContent = 'Send my samples'; });
  });

  // The page gets bottom padding equal to the fixed tray's height, so it never covers the last tiles or the footer.
  (function () {
    var tr = document.querySelector('.gcs-tray');
    if (!tr) return;
    var setH = function () { document.documentElement.style.setProperty('--gcs-tray-h', Math.ceil(tr.getBoundingClientRect().height) + 'px'); };
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(tr); else window.addEventListener('resize', setH);
  })();
  render();
  // Eyebrow from the URL's venue straight away (build() re-applies it with the venue API's name).
  $('gcs-greet').textContent = L.heroEyebrow(P.venue);
  paintWays(P.distributor);
  setOffer(L.showBarsOffer(null, P));
  loadReviews();
  (P.t ? fetchJson(data.api + '/api/crm/venue?t=' + P.t).then(function (r) { return r.ok ? r.json : null; }).catch(function () { return null; }) : Promise.resolve(null))
    .then(function (v) { return build(v && typeof v === 'object' ? v : null); })
    // The 7-day follow-up email links here with ?next=wholesale: open straight on the online-wholesale step.
    .then(function () { if (P.next === 'wholesale') { track('samples_wholesale_benefits_opened', {mode: wsMode(), source: 'followup_email'}); openWholesaleStep(); } });
})();
